export default __webpack_public_path__ + "static/media/academy_card_clip.c6f85630.svg";